import {
  collapsedStyles,
  getDesktopDefaultStyles,
  getDesktopSupportWindowStyles,
  getMobileDefaultStyles,
  getMobileSupportWindowStyles,
  GetStylesParams,
} from '../consts';
import { type DisplayModes } from '../types';

export const getDisplayModeToResponsiveStyles = (
  params: GetStylesParams
): Record<DisplayModes, Record<string, object>> => ({
  FAB_TO_FAC: {
    desktop: getDesktopDefaultStyles(params),
    mobile: getMobileDefaultStyles(params),
  },
  FAB: {
    desktop: { ...getDesktopDefaultStyles(params), ...collapsedStyles },
    mobile: { ...getMobileDefaultStyles(params), ...collapsedStyles },
  },
  FAC: {
    desktop: getDesktopDefaultStyles(params),
    mobile: getMobileDefaultStyles(params),
  },
  WINDOW: {
    desktop: getDesktopSupportWindowStyles(params),
    mobile: getMobileSupportWindowStyles(params),
  },
  HIDDEN: {
    desktop: {},
    mobile: {},
  },
});
